import { FC } from 'react';
import { SpacerSection } from 'components';
import Container from 'components/Layout/Container';
import { SectionHeader } from 'pages/auction/SectionHeader';
import { SectionCountDown } from 'pages/auction/SectionCountDown';
import { SectionDescription } from 'pages/auction/SectionDescription';
import { withLiveAuctionProvider } from 'pages/auction/LiveAuctionProvider';
import { SectionWorking } from 'pages/auction/SectionWorking';
import { SectionWhatToExpect } from 'pages/auction/SectionWhatToExpect';
import { SectionUpcoming } from 'pages/auction/SectionUpcoming';
import { SectionDontMissOut } from '../../src/pages/auction/SectionDontMissOut';

export const Auction: FC = () => {
	return (
		<main style={{ paddingTop: '100px' }}>
			{[
				<SectionHeader />,
				false && <SectionCountDown />,
				<SectionDescription />,
				<SectionWorking />,
				<SectionWhatToExpect />,
				<SectionUpcoming />,
				<SectionDontMissOut />,
			].flatMap((Component, index, array) =>
				array.length - 1 !== index ? [Component, <SpacerSection />] : Component,
			)}
		</main>
	);
};

export default withLiveAuctionProvider(Auction);
